import React from 'react';
import { LockIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../constants/checkout';
type CtaButtonProps = {
  label?: string;
  subLabel?: string;
  className?: string;
};
export function CtaButton({
  label = '👉 SÍ, QUIERO QUE MI BEBÉ DUERMA — ACCESO POR $6.39',
  subLabel = 'Pago seguro · Acceso instantáneo · Garantía de 7 días',
  className = ''
}: CtaButtonProps) {
  return <div className={`w-full ${className}`} data-id="element-12" data-mp="qk21j7bspmfj">
      <a href={CHECKOUT_URL} rel="noopener" className="group flex w-full items-center justify-center rounded-xl bg-coral px-6 py-4 text-center text-[15px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_8px_0_0_#c0421f] transition-all hover:bg-coral-dark hover:shadow-[0_5px_0_0_#c0421f] focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40 active:translate-y-1 active:shadow-[0_2px_0_0_#c0421f] sm:text-base" data-id="element-13" data-mp="qiz9gw2qldy1">
        {label}
      </a>
      <p className="mt-3 flex items-center justify-center gap-1.5 text-xs font-medium text-slateblue-600/80" data-id="element-14" data-mp="15baw7uuk1xzj">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-15" data-mp="35zin6gfh28r5" />
        {subLabel}
      </p>
    </div>;
}